import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  TemplateRef,
  computed,
  effect,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';

import { PopoverDirective, PopoverOptions } from '@fcom/ui-components';

import { SelectorType } from '../../interfaces';
import { BookingWidgetService } from '../../services/booking-widget.service';
type Position = 'left' | 'right';

interface DoubleParams {
  readonly label: string;
  readonly placeholder: string;
  readonly filled: boolean;
}

@Component({
  selector: 'fin-booking-widget-selector',
  templateUrl: 'booking-widget-selector.component.html',
  styleUrls: ['./booking-widget-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingWidgetSelectorComponent {
  private bookingWidgetService = inject(BookingWidgetService);

  readonly widgetType = input<SelectorType>();
  readonly disabled = input(false);
  readonly label = input<string>();
  readonly ariaLabel = input<string>();
  readonly double = input<{
    first: DoubleParams;
    second: DoubleParams;
  }>();
  readonly position = input<Position>();
  readonly filled = input<boolean>();
  readonly placeholder = input<string>();
  readonly popoverOptions = input<PopoverOptions>();
  readonly popoverContent = input<TemplateRef<ElementRef>>();

  readonly close = output<void>();

  readonly popoverDirective = viewChild(PopoverDirective);

  readonly usePopover = computed(() =>
    Boolean(this.bookingWidgetService.usePopoverSelectors() && this.popoverContent() && this.popoverOptions())
  );

  constructor() {
    effect(() => {
      if (!this.usePopover()) {
        return;
      }
      const popoverDirective = this.popoverDirective();
      if (this.bookingWidgetService.modifyType() === this.widgetType() && popoverDirective) {
        popoverDirective.togglePopover();
      }
    });
  }

  handlePopoverClose(): void {
    this.close.emit();
    this.bookingWidgetService.resetModifyType();
  }
}
